import { lazy } from 'react';
/** Открывает форму продукта */
export const ProductFormPageAsync = lazy(() => import('./ProductForm/ProductFormPage'));